// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockOutlinedSvg from "@fishx/icons-svg/es/asn/UnlockOutlined";
import FishxIcon from '../components/FishxIcon';

var UnlockOutlined = function UnlockOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnlockOutlinedSvg
  }));
};

UnlockOutlined.displayName = 'UnlockOutlined';
export default React.forwardRef(UnlockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UnlockOutlined.js
// module id = 4307
// module chunks = 0